import React from 'react';
import { Monogram } from './Monogram';
export function VeraReserve() {
  return <section className="bg-camel border-y border-brass/60" data-id="element-89" data-mp="3ku0v665sqa3o">
      <div className="py-32 md:py-40 px-6 md:px-12 lg:px-24 max-w-7xl mx-auto" data-id="element-90" data-mp="3kshdcb4hrqzs">
        {/* Flagship label — the wordmark lives in the hero; this section carries the promise */}
        <div className="flex flex-col items-center text-center mb-16 md:mb-20" data-id="element-91" data-mp="3budrfdplgs7g">
          <div className="font-mono text-xs uppercase tracking-[0.4em] text-brass mb-8" data-id="element-92" data-mp="ce8uhurruekt">
            The Flagship
          </div>
          <Monogram className="text-sm" rule data-id="element-93" data-mp="8cvkr9lk5r8m" />
        </div>

        {/* Framing line — the retainer as a managed whole */}
        <p className="font-serif font-light text-ink/80 text-xl md:text-2xl text-center max-w-2xl mx-auto mb-24 leading-relaxed" data-id="element-94" data-mp="3f3v6m8dyh7l">
          Your Chief Executive of Health. We handle the training, the meals,
          the travel, the recovery, and the coordination with your physicians
          and specialists. Everything moves in one direction without you
          having to think about it.
        </p>

        {/* The three pillars — Strategic Refinement treatment: large brass
                numeral, brass hairline rule, serif headline, then body */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-12 mb-32" data-id="element-95" data-mp="f3mm8m1eemja">
          <div data-id="element-96" data-mp="k2pro7laiurs">
            <div className="font-serif font-light text-brass text-6xl md:text-7xl leading-none mb-6" data-id="element-97" data-mp="k27n8noh5a8s">
              01
            </div>
            <div className="h-px w-full bg-brass/50 mb-8" aria-hidden="true" data-id="element-98" data-mp="5crzlgk8pkxb" />
            <h3 className="font-serif font-normal uppercase tracking-[0.1em] text-2xl md:text-3xl leading-tight mb-5" data-id="element-99" data-mp="a6mg6b4jtjs6">
              Health Operations
            </h3>
            <p className="font-sans text-base font-light text-ink/70 leading-relaxed" data-id="element-100" data-mp="1c80i7g3w78j">
              Training, nutrition, and recovery, built as one system and
              coordinated alongside your physicians and specialists.
            </p>
          </div>

          <div data-id="element-101" data-mp="34fmd1dq7rqba">
            <div className="font-serif font-light text-brass text-6xl md:text-7xl leading-none mb-6" data-id="element-102" data-mp="34fcpdwsn5v8r">
              02
            </div>
            <div className="h-px w-full bg-brass/50 mb-8" aria-hidden="true" data-id="element-103" data-mp="2zo4e0v7r3zsy" />
            <h3 className="font-serif font-normal uppercase tracking-[0.1em] text-2xl md:text-3xl leading-tight mb-5" data-id="element-104" data-mp="2up06sa4e0c59">
              Travel &amp; Environment
            </h3>
            <p className="font-sans text-base font-light text-ink/70 leading-relaxed" data-id="element-105" data-mp="3ne72l1cginmt">
              Your hotels, gyms, meals, and jet lag are handled before you
              land in any city.
            </p>
          </div>

          <div data-id="element-106" data-mp="3df9ge52i766z">
            <div className="font-serif font-light text-brass text-6xl md:text-7xl leading-none mb-6" data-id="element-107" data-mp="3dezrylx3x73e">
              03
            </div>
            <div className="h-px w-full bg-brass/50 mb-8" aria-hidden="true" data-id="element-108" data-mp="38jkazl3syv2r" />
            <h3 className="font-serif font-normal uppercase tracking-[0.1em] text-2xl md:text-3xl leading-tight mb-5" data-id="element-109" data-mp="222fe96c6du04">
              Executive Integration
            </h3>
            <p className="font-sans text-base font-light text-ink/70 leading-relaxed" data-id="element-110" data-mp="cl1rzyu9g7t3">
              Your team is looped in from week one, so you can focus on
              building while we handle the details.
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center text-center max-w-2xl mx-auto" data-id="element-111" data-mp="r8wir9opk23j">
          <p className="font-serif font-light text-ink/80 text-xl md:text-2xl leading-relaxed mb-12" data-id="element-112" data-mp="rapqyteyyudn">
            The roster is held at eight clients so the standard never slips,
            and three of those seats are open now.
          </p>
          <a href="https://form.jotform.com/262156242446051" target="_blank" rel="noopener noreferrer" className="cta-link" data-id="element-113" data-mp="158ecm3gv25jr">
            Begin the Application
            <span className="ml-2 font-serif text-lg leading-none" data-id="element-114" data-mp="371c7s5y41a7v">→</span>
          </a>
        </div>
      </div>
    </section>;
}